import * as yup from 'yup';

export default yup.object({
  apps: yup.array().of(yup.string().required()).min(1).required(),
});
